// DTM
import React from "react";
import styled from "styled-components";

import scale, { center } from "../helper/scaling";
import ArticleAbstract from "./ArticleAbstract";

const Wrapper = styled.div`
  width: 100%;
  height: 425px;
  float: left;
  position: relative;
  @media (max-width: 1100px) {
    height: ${scale(1100, 767, 425, 275, "vw")};
  }
  @media (max-width: 700px) {
    height: auto;
  }
`;
const GrayBlock = styled.div`
  width: 910px;
  height: 310px;
  position: absolute;
  top: 75px;
  left: calc(50% - 455px);
  background-color: #f9f9f9;
  @media (max-width: 1100px) {
    width: ${scale(1100, 767, 910, 550)};
    height: ${scale(475, 323, 310, 232)};
    left: ${center(1100, 767, 910, 550)};
    top: ${scale(475, 323, 75, 31)};
  }
  @media (max-width: 700px) {
    height: 0;
    width: 0;
    top: 0;
    left: 0;
    display: none;
  }
`;
const Content = styled.div`
  width: 1040px;
  height: 100%;
  position: absolute;
  left: calc(50% - 520px);
  display: flex;
  justify-content: space-between;
  align-items: center;
  @media (max-width: 1100px) {
    width: ${scale(1100, 767, 1040, 678)};
    left: ${center(1100, 767, 1040, 678)};
  }
  @media (max-width: 700px) {
    width: 100%;
    position: relative;
    height: auto;
    left: 0;
    display: block;
    float: left;
  }
`;
const Block = styled.div`
  width: 535px;
  @media (max-width: 1100px) {
    width: 50%;
  }
  @media (max-width: 700px) {
    width: 100%;
    position: relative;
    height: auto;
    display: block;
    float: left;
  }
`;
const Title = styled.div`
  width: 100%;

  font-family: Lato;
  font-size: 42px;
  font-weight: 900;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.38;
  letter-spacing: 0.6px;
  color: rgba(0, 0, 0, 0.85);
  @media (max-width: 1100px) {
    font-size: ${scale(1100, 767, 42, 27, "vw")};

    letter-spacing: 0.4px;
  }
  @media (max-width: 800px) {
    line-height: 1.41;
  }
  @media (max-width: 700px) {
    padding: 35px 23px 22px 23px;
    width: calc(100% - 46px);
    float: left;
    font-size: 23px;
    line-height: 1.35;
    letter-spacing: 0.3px;
  }
`;
const Body = styled.div`
  width: 100%;

  margin-top: 0.5em;

  font-family: Lato;
  font-size: 18px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.67;
  letter-spacing: 1.3px;
  color: rgba(0, 0, 0, 0.85);
  @media (max-width: 1100px) {
    font-size: ${scale(1100, 767, 18, 14, "vw")};

    letter-spacing: 1px;
  }
  @media (max-width: 800px) {
    line-height: 1.71;
  }
  p {
    margin-top: 0.5em;
    margin-bottom: 0.5em;
  }
  @media (max-width: 700px) {
    padding: 30px 23px 35px 23px;
    margin: 0;
    width: calc(100% - 46px);
    float: left;
    font-size: 12px;
    line-height: 1.75;
    letter-spacing: 0.8px;
  }
`;
const Image = styled.div`
  width: 489px;
  height: 378px;
  background-position: center center;
  background-repeat: no-repeat;
  background-size: contain;
  @media (max-width: 1100px) {
    width: 50%;
    height: ${scale(475, 323, 378, 270)};
  }
  @media (max-width: 700px) {
    width: 0;
    height: 0;
    display: none;
  }
`;
const InlineImage = styled.img`
  height: 0;
  width: 0;
  display: none;
  overflow: hidden;
  @media (max-width: 700px) {
    width: calc(100% - 46px);
    margin: 0 23px 0 23px;
    float: left;
    display: block;
    height: auto;
  }
`;

class ArticleGray extends ArticleAbstract {
  // image
  // title
  // body
  render() {
    return (
      <Wrapper>
        <GrayBlock />
        <Content>
          <Block>
            <Title>{this.title()}</Title>
            <InlineImage src={this.imageUrl()} />
            <Body>{this.body()}</Body>
          </Block>
          <Image style={this.image()} />
        </Content>
      </Wrapper>
    );
  }
}

export default ArticleGray;



// WEBPACK FOOTER //
// ./src/components/ArticleGray.js